import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import 'bootstrap/dist/css/bootstrap.css';
import './custom.scss';
import './global.scss';

ReactDOM.render(<App />, document.getElementById('root'));
